function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { STORAGE_KEYS as t } from "./storage-manager.js";
import u from "./subscription-manager.js";
import Jt from "../models/server-config.js";
import c from "../common/event-logger.js";
import { EventTypes as d } from "../../shared-lib/index.js";

var Dt = /*#__PURE__*/function () {
  function Dt(t) {
    _classCallCheck(this, Dt);

    this.C = t, this.C = t, this.al = new u(), this.hl = new u(), this.ul = new u(), this.cl = new u(), this.ml = null, this.gl = null;
  }

  _createClass(Dt, [{
    key: "bl",
    value: function bl() {
      if (null == this.gl) {
        var e = this.C.ps(t.bs.fl);
        this.gl = null != e ? Jt.Qn(e) : new Jt();
      }

      return this.gl;
    }
  }, {
    key: "Es",
    value: function Es() {
      return this.bl().dl;
    }
  }, {
    key: "Rl",
    value: function Rl(e) {
      var _this = this;

      if (null != e && null != e.config) {
        var i = e.config;

        if (i.time > this.bl().dl) {
          var _e = function _e(t) {
            return null == t ? _this.bl().Cl : t;
          },
              s = new Jt(i.time, i.events_blacklist, i.attributes_blacklist, i.purchases_blacklist, i.messaging_session_timeout, i.vapid_public_key, i.content_cards, i.feature_flags, _e(i.global_request_rate_limit), i.banners);

          var n = !1;
          null != s.El && this.Gn() !== s.El && (n = !0);
          var r = !1;
          null != s.vl.enabled && this.Xi() !== s.vl.enabled && (r = !0);
          var l = !1;
          null != s.Gi.enabled && this.Qi() !== s.Gi.enabled && (l = !0);
          var a = !1;
          null != s.banners.enabled && this.Us() !== s.banners.enabled && (a = !0), this.gl = s, this.C.js(t.bs.fl, s.Bs()), n && this.al.X(), r && this.hl.X(), l && this.ul.X(), a && this.cl.X();
        }
      }
    }
  }, {
    key: "Hn",
    value: function Hn(t) {
      var e = this.al.Ns(t);
      return this.ml && this.al.removeSubscription(this.ml), this.ml = e, e;
    }
  }, {
    key: "$i",
    value: function $i(t) {
      return this.hl.Ns(t);
    }
  }, {
    key: "Re",
    value: function Re(t) {
      return this.ul.Ns(t);
    }
  }, {
    key: "A",
    value: function A(t) {
      return this.cl.Ns(t);
    }
  }, {
    key: "ge",
    value: function ge(t) {
      return -1 !== this.bl().wl.indexOf(t);
    }
  }, {
    key: "hu",
    value: function hu(t) {
      return -1 !== this.bl().yl.indexOf(t);
    }
  }, {
    key: "Dr",
    value: function Dr(t) {
      return -1 !== this.bl().Ll.indexOf(t);
    }
  }, {
    key: "Bl",
    value: function Bl() {
      return this.bl().Fl;
    }
  }, {
    key: "Gn",
    value: function Gn() {
      return this.bl().El;
    }
  }, {
    key: "Xi",
    value: function Xi() {
      return this.bl().vl.enabled || !1;
    }
  }, {
    key: "Tl",
    value: function Tl() {
      var t = this.bl().Cl;
      return !(!t || null == t.enabled) && t.enabled;
    }
  }, {
    key: "il",
    value: function il() {
      if (!this.Tl()) return -1;
      var t = this.bl().Cl;
      return null == t.capacity || t.capacity < 10 ? -1 : t.capacity;
    }
  }, {
    key: "sl",
    value: function sl() {
      if (!this.Tl()) return -1;
      var t = this.bl().Cl;
      return null == t.refill_rate || t.refill_rate <= 0 ? -1 : t.refill_rate;
    }
  }, {
    key: "jl",
    value: function jl(t) {
      var e = this.bl().Cl.endpoint_overrides;
      return null == e ? null : e[t];
    }
  }, {
    key: "rl",
    value: function rl(t) {
      var e = this.jl(t);
      return null == e || isNaN(e.capacity) || e.capacity <= 0 ? -1 : e.capacity;
    }
  }, {
    key: "ol",
    value: function ol(t) {
      var e = this.jl(t);
      return null == e || isNaN(e.refill_rate) || e.refill_rate <= 0 ? -1 : e.refill_rate;
    }
  }, {
    key: "Qi",
    value: function Qi() {
      return this.bl().Gi.enabled && null == this.Se() ? (c.ds(d.Li, {
        e: "Missing feature flag refresh_rate_limit."
      }), !1) : this.bl().Gi.enabled || !1;
    }
  }, {
    key: "Se",
    value: function Se() {
      return this.bl().Gi.refresh_rate_limit;
    }
  }, {
    key: "Us",
    value: function Us() {
      return this.bl().banners.enabled || !1;
    }
  }, {
    key: "ee",
    value: function ee() {
      return this.bl().banners.max_placements || 0;
    }
  }]);

  return Dt;
}();

export { Dt as default };